/**
 * The editor's top-level workspace tabs, in TopBar order.
 *
 * This is the one source of truth for tab order, labels and their default
 * Ctrl+<n> keys: the web TopBar, the shortcut registry, the command palette and
 * the desktop shell's native View menu all read it, so they can never disagree.
 */
export const WORKSPACE_TABS = [
  { id: 'scene', label: 'Scene', key: '1' },
  { id: 'model', label: 'Model', key: '2' },
  { id: 'pixel', label: 'Pixel', key: '3' },
  { id: 'sound', label: 'Sound', key: '4' },
  { id: 'play', label: 'Play', key: '5' },
  { id: 'code', label: 'Code', key: '6' },
  { id: 'board', label: 'Board', key: '7' },
  { id: 'video', label: 'Video', key: '8' },
] as const;

export type WorkspaceTabId = (typeof WORKSPACE_TABS)[number]['id'];

/** Shortcut-registry command id that switches to a workspace tab. */
export function tabCommandId(tab: WorkspaceTabId): string {
  return `view.tab.${tab}`;
}

/**
 * Native menu accelerators the renderer hands the desktop shell when it pops a
 * menu: command id -> Electron accelerator ("CmdOrCtrl+1"). Native popups only
 * display accelerators (the app menu is unset), so these are labels that track
 * the user's current key bindings.
 */
export type MenuAccelerators = Readonly<Record<string, string>>;
